import { render, staticRenderFns } from "./legalCounsel.vue?vue&type=template&id=51554ddf&scoped=true&"
import script from "./legalCounsel.vue?vue&type=script&lang=js&"
export * from "./legalCounsel.vue?vue&type=script&lang=js&"
import style0 from "./legalCounsel.vue?vue&type=style&index=0&id=51554ddf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51554ddf",
  null
  
)

export default component.exports